import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-zinc-900">
      {/* Background Image - Professional Jewelry Photography Style */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_3b8642099d6f14672a4f4d1fb96790a6_12ce8cd4.jpg"
          alt="三鑑所 - 奢華資產收藏"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/30"></div>
      </div>

      <div className="relative w-full min-h-screen flex items-center px-8 lg:px-20 xl:px-32 py-32">
        <div
          className={`max-w-2xl transition-all duration-1000 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Top Label */}
          <div
            className={`mb-12 transition-all duration-700 delay-100 ${
              visible ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <span className="text-[11px] font-medium tracking-[0.4em] text-white/50 uppercase">
              Tricore Authentication
            </span>
          </div>

          {/* Main Headline */}
          <h1
            className={`mb-8 transition-all duration-700 delay-200 ${
              visible ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <span className="block font-heading text-[clamp(5rem,12vw,9rem)] leading-[0.95] text-white tracking-tight font-bold">
              三鑑所
            </span>
          </h1>

          {/* Sub-headline */}
          <p
            className={`text-[clamp(1.6rem,3.5vw,2.4rem)] leading-[1.3] text-white/90 mb-12 font-light tracking-widest transition-all duration-700 delay-300 ${
              visible ? 'opacity-100' : 'opacity-0'
            }`}
          >
            鑑真・識貨・懂買
          </p>

          {/* Divider Line */}
          <div
            className={`h-px bg-white/30 mb-12 transition-all duration-1000 delay-400 ${
              visible ? 'w-32' : 'w-0'
            }`}
          ></div>

          {/* Product List */}
          <div
            className={`mb-4 transition-all duration-700 delay-500 ${
              visible ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <span className="text-[clamp(1rem,2vw,1.25rem)] font-semibold text-white/80 tracking-wider">
              精品箱包<span className="mx-4 text-white/30">｜</span>翡翠<span className="mx-4 text-white/30">｜</span>寶石
            </span>
          </div>

          {/* Service Definition */}
          <p
            className={`text-[15px] text-white/50 mb-14 tracking-wide transition-all duration-700 delay-600 ${
              visible ? 'opacity-100' : 'opacity-0'
            }`}
          >
            第三方鑑定與顧問
          </p>

          {/* Primary Button - Outline Style */}
          <div
            className={`transition-all duration-700 delay-700 ${
              visible ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <a
              href="#appointment"
              className="inline-flex items-center gap-3 px-10 py-4 border border-white/50 text-white font-medium text-[14px] tracking-wider hover:bg-white hover:text-neutral-900 transition-all duration-300 cursor-pointer whitespace-nowrap group"
            >
              預約鑑定服務
              <i className="ri-arrow-right-line text-base group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>

          {/* Trust Badges */}
          <div
            className={`mt-20 flex flex-wrap items-center gap-5 transition-all duration-1000 delay-800 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <div className="flex items-center gap-2 px-4 py-2 bg-white/5 backdrop-blur-sm border border-white/10">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-robot-2-line text-base text-white/50"></i>
              </div>
              <span className="text-[11px] text-white/50 tracking-wider">Entrupy AI</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-white/5 backdrop-blur-sm border border-white/10">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-smartphone-line text-base text-white/50"></i>
              </div>
              <span className="text-[11px] text-white/50 tracking-wider">Legit App</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-white/5 backdrop-blur-sm border border-white/10">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-verified-badge-line text-base text-white/50"></i>
              </div>
              <span className="text-[11px] text-white/50 tracking-wider">中檢標準</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-8 lg:left-20 xl:left-32 flex items-center gap-3 z-10">
        <div className="w-px h-12 bg-white/20 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1/2 bg-white/60 animate-pulse"></div>
        </div>
        <span className="text-[10px] text-white/40 tracking-[0.2em] uppercase">Scroll</span>
      </div>
    </section>
  );
}
